import React from "react";
import styles from "./zodiac.module.css";
import { Page } from "../../components/page/page";
import { useSelector } from "react-redux";

import Aries from "./images/aries.svg";
import Taurus from "./images/taurus.svg";
import Gemini from "./images/gemini.svg";
import Cancer from "./images/cancer.svg";
import Leo from "./images/leo.svg";
import Virgo from "./images/virgo.svg";
import Libra from "./images/libra.svg";
import Scorpio from "./images/scorpio.svg";
import Sagittarius from "./images/sagittarius.svg";
import Capricorn from "./images/capricorn.svg";
import Aquarius from "./images/aquarius.svg";
import Pisces from "./images/pisces.svg";
import findZodiacSign from "./sings";

const sings = {
  Aries: Aries,
  Taurus: Taurus,
  Gemini: Gemini,
  Cancer: Cancer,
  Leo: Leo,
  Virgo: Virgo,
  Libra: Libra,
  Scorpio: Scorpio,
  Sagittarius: Sagittarius,
  Capricorn: Capricorn,
  Aquarius: Aquarius,
  Pisces: Pisces
};

const ZodiacPage = ({title, nextPageLink, isPartner = false}) => {
  const state = useSelector((store) => store.dateBirth);
  const zodiacSign = !isPartner
    ? findZodiacSign(state.birthDate.day, state.birthDate.month)
    : findZodiacSign(state.partnerBirthDate.day, state.partnerBirthDate.month);

  return (
    <Page title="Your zodiac sign is..." nextPageLink="../relationship-status" hideSteps={true}>
      <div>
        <h2 className={styles.sign}>{zodiacSign}</h2>
        <img
          src={sings[zodiacSign]}
          className={styles.sign_image}
          alt={zodiacSign}
        />
      </div>
    </Page>
  );  
};

export { ZodiacPage };
